@if (!loading() && DetailsComponent()) {
  <ng-container *ngComponentOutlet="DetailsComponent(); inputs: {dialogRef: dialogRef, folder: folder(), reload: reload.bind(this)}"></ng-container>
  <mat-toolbar class="footer">
    <div class="expander"></div>
      @if (!closed) {
        <button mat-raised-button color="accent" (click)="closeFolder()">
          <mat-icon>close</mat-icon>
          <span class="hide-mobile">Cerrar {{'folder' | human}}</span>
        </button>
      }
  </mat-toolbar>
} @else {
  <mat-spinner></mat-spinner>
}
